import React, { useState, useContext } from 'react';
import { IconCaretDown } from '@wds/icons';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { Accordion } from '@wds/accordion';
import { List } from '@wds/list';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import MenuItems from '../info-menu/MenuItems';

import ExplorePanel from './ExplorePanel';

const ExploreMenu = () => {
  const [show, setShow] = useState(false);
  const { pageURL, pageName } = useContext(HeaderContext);

  const trackMenuEvents = (opened: boolean) => {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName,
        amplitudeEvent: 'header clicked menu',
        menuName: 'explore',
        opened,
      },
    });
  };

  const onToggle = () => {
    trackMenuEvents(!show);
    setShow(!show);
  };

  return (
    <Responsive minWidth="xl">
      {(matches: boolean) =>
        matches ? (
          <div>
            <NavButton label="Open explore menu" onClick={onToggle}>
              Explore
              <Box ml={2}>
                <IconCaretDown title="Dropdown arrow icon" />
              </Box>
            </NavButton>
            <ExplorePanel show={show} onToggle={onToggle} />
          </div>
        ) : (
          <Accordion
            key="accordion-Explore"
            noRules
            interactive
            onChange={e => trackMenuEvents(!e.length)}
          >
            <Accordion.Item title="Explore">
              <List noRules interactive>
                <MenuItems
                  title="Audience"
                  url="https://www.surveymonkey.com/collect/audience/calculator/preview?ut_source=header&ut_source3=buy_targeted_responses"
                  navItem="audience"
                  subTitle=""
                />
                <MenuItems
                  title=" Brand and market research"
                  url="https://www.surveymonkey.com/market-research/solutions/get-started/?ut_source=header"
                  navItem=" Brand and market research"
                  subTitle=""
                />
              </List>
            </Accordion.Item>
          </Accordion>
        )
      }
    </Responsive>
  );
};

// eslint-disable-next-line import/prefer-default-export
export { ExploreMenu };
